import { FC, useState } from "react"
import { Dialog } from 'primereact/dialog';
import { Button } from "primereact/button";
import { FiCommand } from "react-icons/fi";
import { TfiSave } from "react-icons/tfi";
import { catchResponse } from "../../../../utils/helperFunctions";
import { changeCampaignYear } from "../../../../services/home-service";
import { error, success } from "../../../../utils/notifications";
import moment from "moment";

export const ChangeCampaignModal:FC<any> = (props):JSX.Element => {

    const { visible, setVisible, id,name, anio, flag, setFlag } = props

   
    const [campaignYear, setCampaignYear] = useState<any>()

    const [referenceYear, setReferenceYear] = useState<any>()

    const [loadingChangeYear, setLoadingChangeYear] = useState<boolean>(false)

    const currentYear = new Date().getFullYear();
    const startYear = 2022;
    const years = [];

    for (let year = startYear; year <= currentYear + 1; year++) {
    years.push(year);
    }
   const handleChangeYear = (e:any) => {
    setCampaignYear(e.target.value)
   }

   const handleChangeReferenceYear = (e:any) => {
    setReferenceYear(e.target.value)
   }

    const handleCloseModal = () => {
        setVisible(false)
        setCampaignYear(undefined)
        setReferenceYear(undefined)
    }


    const handleChangeCampaignYear = async() => {
        try {
            setLoadingChangeYear(true)
            let body = {
                id_plant : id,
                name_plant: name,
                new_year : parseInt(campaignYear),
                reference_year : parseInt(referenceYear)
            }

            const res = await changeCampaignYear(body)
            if(res.status === 200) {
                const { message } = res.data
                success(message)
                setFlag(!flag)
                handleCloseModal()
            } else {
                error("Error cambiando el año de campaña")
                handleCloseModal()
            }
            setLoadingChangeYear(false)
        } catch (error:any) {
            catchResponse(error)
            setLoadingChangeYear(false)
        }
    }

   
    return (
        <Dialog header={`Cambiar año de campaña ${name}`} headerStyle={{padding:'0.75rem'}} visible={visible} style={{ width: '35vw' }} onHide={handleCloseModal}>
            <div className="new_scenario_container">
                <p style={{fontSize:'0.95rem',fontFamily:'var(--roboto-medium)'}} >
                    El año de campaña actual es : <b><i>{anio}</i></b>
                </p>
                <p style={{fontSize:'0.95rem',fontFamily:'var(--roboto-medium)'}} >
                   <>Selecciona el año de campaña al que quieres cambiar</>
                   <select onChange={handleChangeYear} className="select-anio" value={campaignYear} style={{marginLeft:'1rem',padding:'0.5rem',borderRadius:5,fontFamily:'var(--roboto-medium)'}}>
                        <option value={undefined}></option>
                        {
                            years.filter(item => item!=anio && !(new Date() < new Date(new Date().getFullYear(), 7, 1) && item == new Date().getFullYear()) && !(item > new Date().getFullYear())  ).map((year:number) => {
                                return (
                                    <option key={year} value={year}>{year}</option> 
                                )
                            })
                        }
                        
                   </select>
                </p>
                <p style={{fontSize:'0.95rem',fontFamily:'var(--roboto-medium)'}} >
                   <>Selecciona el año de referencia para la campaña futura</>
                   <select onChange={handleChangeReferenceYear} className="select-anio" value={referenceYear} style={{marginLeft:'1rem',padding:'0.5rem',borderRadius:5,fontFamily:'var(--roboto-medium)'}}>
                        <option  value={undefined}></option>
                        {
                            Array.from({ length: (moment().year() - 1) - 2022 + 1 }, (_, index) => 2022 + index).map((year:number) => {
                                return (
                                    <option key={year} value={year}>{year}</option> 
                                )
                            })
                        }
                        
                   </select>
                </p>
                
                
                
                <p style={{fontSize:'0.95rem',fontFamily:'var(--roboto-medium)'}} >
                    ¿Estás seguro de querer continuar? <i><small>Esta acción será <b><u>irreversible</u></b> y se aplicará a las 07:00 AM.</small></i>
                </p>
                

                
                
            </div>
            
            <div className="scenarios-footer pb-1">
                <Button onClick={handleChangeCampaignYear} severity={'success'} style={{minWidth:220}} disabled={loadingChangeYear || (referenceYear === undefined || campaignYear === undefined)} label={loadingChangeYear? "Cambiando año" : "Cambiar año"} icon={loadingChangeYear? <FiCommand className="loading-icon" style={{fontSize:18,marginRight:'1rem',color:'#22C55E'}} /> :<TfiSave style={{fontSize:18,marginRight:'1rem'}} />}    outlined />
                <Button severity={'danger'} style={{minWidth:220}} disabled={loadingChangeYear} label="Cancelar" icon="pi pi-times"  outlined  onClick={handleCloseModal} />

            </div>
        </Dialog>
    )
}